import { render } from "./photo.vue?vue&type=template&id=6ae07595"
import script from "./photo.vue?vue&type=script&lang=js"
export * from "./photo.vue?vue&type=script&lang=js"

import exportComponent from "C:\\devPrivate\\cmsDubaiMailing\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__